import { createTheme, Theme } from "@mui/material";

declare module "@mui/styles/defaultTheme" {
  interface DefaultTheme extends Theme {}
}

export const CustomTheme = createTheme({
  palette: {
    primary: {
      light: "#3B82F6",
      main: "#6b7280",
      dark: "#1E40AF",
      contrastText: "#fff",
    },
    secondary: {
      main: "#F84C54",
      light: "#FEDBDD",
      dark: "#EA3F47",
      contrastText: "#fff",
    },
    success: {
      main: "#28a745",
    },
    background: {
      default: "#DBEAFE",
    },
  },
  typography: {
    button: {
      textTransform: "none",
    },
  },
  components: {
    MuiSelect: {
      styleOverrides: {
        select: {
          "& .MuiSelect-select:focus": {
            backgroundColor: "white",
          },
        },
      },
    },
  },
});
